import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CustomErrorHandlerService } from '../custom-error-handler.service';
import { AIResponseModel } from '../../../models/ai-response/ai-response.model';
import { AIResponseSerializer } from '../../../models/ai-response/ai-response-serializer.class';
import { AIPromptDataRequest } from '../../../models/ai-prompt-data-request/ai-prompt-data-request.model';
import { AIPromptDataRequestSerializer } from '../../../models/ai-prompt-data-request/ai-prompt-data-request-serializer.class';


import { Observable } from "rxjs";
/**
 * Service to communicate with API Client Users
 */

@Injectable()
export class AIPromptService extends BaseApiService<AIResponseModel> {
    constructor(httpClient: HttpClient) {
        super(
            httpClient,
            null,
            "ai",
            new AIResponseSerializer(),
            new CustomErrorHandlerService());
    }

    handlePrompt(prompt: AIPromptDataRequest): Observable<AIResponseModel> {
        return this.httpClient.post<AIResponseModel>(
            `${this.url}/ai/handle`,
            prompt
        );
    }
}
